import "./GiftNote.css";

export default function GiftNote(): JSX.Element {
  return (
    <section className="giftNote" id="gift">
      <div className="container giftNote__inner">
        <div className="giftNote__copy">
          <p className="giftNote__eyebrow">Ajándék</p>
          <h2>Nászajándék</h2>
          <p>
            Mindenünk megvan, amire szükségünk lehet, és számunkra a jelenlétetek
            a legnagyobb ajándék. Ha mégis szeretnétek meglepni minket, egy
            borítékban szívesen fogadunk hozzájárulást Marci pilótaképzéséhez,
            Fanni ehhez kapcsolódó nyugtatójához vagy szerencsétlen kutyánk
            életkörülményeinek javításához. Ezt a{" "}
            <strong>menyasszonytánc alatt</strong> lesz lehetőségetek átadni.
          </p>
        </div>

        <figure className="giftNote__image">
          <img
            src="/images/bibi.jpg"
            alt="Bibi, Fanni és Marci kutyája a kanapén pihen"
            width="1800"
            height="1350"
            loading="lazy"
          />
        </figure>
      </div>
    </section>
  );
}
